import { c as _c } from "react/compiler-runtime";
import type { Mat } from 'opencv-react-ts';
import { OpenCvContext } from 'opencv-react-ts';
import type { ContextType, ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { getOpenCvUrl } from '../constants';
type OpenCvState = ContextType<typeof OpenCvContext>;
let openCvLoad: Promise<OpenCvState['cv']> | undefined;

// The build leaves a promise of the module in window.cv, not the module.
const loadOpenCv = () => {
  openCvLoad ??= new Promise<OpenCvState['cv']>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = getOpenCvUrl();
    script.async = true;
    script.onload = () => resolve(window.cv);
    script.onerror = () => reject(new Error('OpenCV failed to load'));
    document.body.appendChild(script);
  }).then(cv => {
    // OpenCV installs its own mat_clone() swap after this build initializes, so clone() would alias.
    const matPrototype: {
      clone: () => Mat;
      mat_clone?: () => Mat;
    } | undefined = cv?.Mat.prototype;
    if (matPrototype?.mat_clone) {
      matPrototype.clone = matPrototype.mat_clone;
    }
    return cv;
  });
  return openCvLoad;
};
const OpenCvProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      loaded: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [state, setState] = useState(t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      let mounted = true;
      loadOpenCv().then(cv => {
        if (mounted) {
          setState({
            loaded: true,
            cv
          });
        }
      }).catch(_temp);
      return () => {
        mounted = false;
      };
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== children || $[4] !== state) {
    t4 = <OpenCvContext.Provider value={state}>{children}</OpenCvContext.Provider>;
    $[3] = children;
    $[4] = state;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export { OpenCvProvider };
function _temp() {}